import { StepRun } from "@/models/flows";

interface Props {
  stepRun: StepRun;
}

export const RequestPayment = ({ stepRun }: Props) => {
  return <>coming soon tm</>;
};
